module.exports = __webpack_public_path__ + "static/media/ramon_vilarino.39569985.jpg";